(function () {
  if (window.HederaStickyHeaderCoordinatesBreadcrumbs) return;

  const initialized = new WeakSet();

  function initializeBreadcrumb(element) {
    if (!element || initialized.has(element) || element.dataset.hdSticky !== 'true') return;

    initialized.add(element);

    const header = document.querySelector('.header_bottom.header__sticky') || document.querySelector('.header__sticky');
    const stickyShell = element.closest('[data-hd-breadcrumbs-shell]');
    if (!stickyShell) return;

    let frame = 0;
    let breadcrumbHeight = Math.ceil(element.getBoundingClientRect().height);

    function update() {
      frame = 0;

      const headerIsFixed = header && header.classList.contains('sticky');
      const headerBottom = headerIsFixed ? Math.max(0, Math.ceil(header.getBoundingClientRect().bottom)) : 0;
      const shellTop = Math.ceil(stickyShell.getBoundingClientRect().top);
      const shouldStick = window.scrollY > 0 && shellTop <= headerBottom + 1;

      stickyShell.style.setProperty('--hd-breadcrumb-sticky-top', headerBottom + 'px');
      stickyShell.style.setProperty('--hd-breadcrumb-height', breadcrumbHeight + 'px');
      stickyShell.classList.toggle('hd-breadcrumbs-shell--stuck', shouldStick);
      element.classList.toggle('hd-breadcrumbs--stuck', shouldStick);
    }

    function scheduleUpdate() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }

    function refreshMeasurements() {
      breadcrumbHeight = Math.ceil(element.getBoundingClientRect().height);
      scheduleUpdate();
    }

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', refreshMeasurements, { passive: true });
    window.addEventListener('pageshow', refreshMeasurements, { passive: true });

    if (header && 'MutationObserver' in window) {
      const classObserver = new MutationObserver(scheduleUpdate);
      classObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    if ('ResizeObserver' in window) {
      const sizeObserver = new ResizeObserver(refreshMeasurements);
      sizeObserver.observe(element);
      if (header) sizeObserver.observe(header);
    }

    update();
  }

  function initializeAll(root) {
    const scope = root || document;

    if (scope.matches && scope.matches('[data-hd-breadcrumbs]')) {
      initializeBreadcrumb(scope);
    }

    scope.querySelectorAll('[data-hd-breadcrumbs]').forEach(initializeBreadcrumb);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    }, { once: true });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
